import type { UseBannerCarouselProps, UseBannerCarouselResult } from "@/types/types"
import { useMemo } from "react"

export const useBannerCarousel = ({
  banners = [],
  componentId,
  autoplayDelay = 5000,
}: UseBannerCarouselProps): UseBannerCarouselResult => {
  // Lọc banners hợp lệ
  const validBanners = useMemo(() => {
    return banners.filter(banner => banner.image && banner.image.trim())
  }, [banners])

  const hasValidBanners = validBanners.length > 0

  // Tính toán config cho Swiper
  const swiperConfig = useMemo(() => {
    const shouldLoop = validBanners.length >= 1
    const shouldAutoplay = validBanners.length > 1

    return {
      loop: shouldLoop,
      autoplay: shouldAutoplay
        ? {
            delay: autoplayDelay,
            disableOnInteraction: false,
          }
        : false,
      pagination: {
        clickable: true,
      },
    }
  }, [validBanners.length, autoplayDelay])

  // Tạo unique ID
  const id = useMemo(() => componentId || `banner-carousel-${Math.random().toString(36).substr(2, 9)}`, [componentId])

  return {
    validBanners,
    hasValidBanners,
    swiperConfig,
    id,
  }
}
